import { cn } from "@/lib/utils";
import { isNativeShell } from "@/lib/oauthRedirect";
import { APP_STORE_URL } from "@/lib/appStore";

interface AppStoreBadgeProps {
  className?: string;
}

export function AppStoreBadge({ className }: AppStoreBadgeProps) {
  if (isNativeShell()) return null;

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Grounded on the App Store"
      className={cn(
        "inline-block align-middle transition-opacity hover:opacity-80",
        className,
      )}
    >
      <svg
        viewBox="0 0 120 40"
        width="120"
        height="40"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        className="block h-auto w-full"
      >
        <rect width="120" height="40" rx="6" fill="black" />
        <rect x="0.5" y="0.5" width="119" height="39" rx="5.5" stroke="white" strokeOpacity="0.25" fill="none" />
        <text
          x="60"
          y="12.5"
          textAnchor="middle"
          fill="white"
          fontSize="5.5"
          fontFamily="-apple-system, SF Pro Text, Helvetica Neue, sans-serif"
          letterSpacing="0.02em"
        >
          Download on the
        </text>
        <text
          x="60"
          y="28"
          textAnchor="middle"
          fill="white"
          fontSize="11"
          fontWeight="600"
          fontFamily="-apple-system, SF Pro Display, Helvetica Neue, sans-serif"
          letterSpacing="-0.01em"
        >
          App Store
        </text>
        {/* Apple logo */}
        <g transform="translate(16, 10)" fill="white">
          <path d="M9.438 5.865c-.013-1.477 1.203-2.194 1.259-2.229-.69-1.007-1.759-1.144-2.134-1.155-.9-.095-1.775.54-2.236.54-.468 0-1.175-.531-1.938-.515-.983.015-1.902.584-2.406 1.47-1.04 1.8-.265 4.454.732 5.913.497.715 1.082 1.514 1.847 1.486.746-.03 1.025-.48 1.925-.48.895 0 1.152.48 1.925.463.8-.013 1.305-.72 1.793-1.44.576-.822.808-1.63.82-1.672-.018-.006-1.568-.604-1.587-2.381zM7.953 1.612C8.36 1.114 8.637.433 8.56-.166c-.585.025-1.313.402-1.733.893-.371.432-.705 1.14-.618 1.806.657.05 1.333-.335 1.744-.921z" />
        </g>
      </svg>
    </a>
  );
}
